/**
 * Reads a localized value out of the JSON that MultilingualJsonInterceptor keeps in
 * `_multilingual_original_{field}`, falling back to any non-empty translation.
 */
export function extractMultilingualValueString(value: string, defaultReturn: string | null, activeLang: string): string | null {
  try {
    const parsed = JSON.parse(value) as Record<string, string>;
    if (parsed[activeLang]?.trim()) return parsed[activeLang];
    for (const value of Object.values(parsed)) {
      if (value?.trim()) return value;
    }
    return defaultReturn;
  } catch {
    return defaultReturn;
  }
}
